 /**
  * Status Constants
  * 
  * Defines all status enums used across the system.
  * These match database column values.
  */
 
 // Account status for buyer_profiles.status
 export const ACCOUNT_STATUS = {
   ACTIVE: 'active',
   SUSPENDED: 'suspended',
   DELETED_REQUESTED: 'deleted_requested',
 } as const;
 
 // Organization status for dealer_accounts.status
 export const ORG_STATUS = {
   PENDING: 'pending',
   APPROVED: 'approved',
   SUSPENDED: 'suspended',
 } as const;
 
 // Member status for dealer team members
 export const MEMBER_STATUS = {
   ACTIVE: 'active',
   INACTIVE: 'inactive',
 } as const;
 
 // Entitlement status (from Stripe sync)
 export const ENTITLEMENT_STATUS = {
   // Access granted
   ACTIVE: 'active',
   TRIALING: 'trialing',
   // Access denied
   PAST_DUE: 'past_due',
   CANCELED: 'canceled',
   UNPAID: 'unpaid',
   INCOMPLETE: 'incomplete',
   INCOMPLETE_EXPIRED: 'incomplete_expired',
   PAUSED: 'paused',
 } as const;
 
 // Statuses that grant subscriber access
 export const ENTITLEMENT_GRANTED_STATUSES = [
   ENTITLEMENT_STATUS.ACTIVE,
   ENTITLEMENT_STATUS.TRIALING,
 ] as const;
 
 // Type exports
 export type AccountStatus = typeof ACCOUNT_STATUS[keyof typeof ACCOUNT_STATUS];
 export type OrgStatus = typeof ORG_STATUS[keyof typeof ORG_STATUS];
 export type MemberStatus = typeof MEMBER_STATUS[keyof typeof MEMBER_STATUS];
 export type EntitlementStatus = typeof ENTITLEMENT_STATUS[keyof typeof ENTITLEMENT_STATUS];